module.exports = __webpack_public_path__ + "img/b7.b91b5fa2.jpg";